export default {
  schools: (state) => {
    if (state && state.results) {
      if (Array.isArray(state.results.data) && state.results.data.length > 0) {
         return state.results.data;
      }
    }
    return [];
  },

  school: state => state.selected,

  delegatedSchools: state => state.delegatedSchools,

  childSchools: state => state.childSchools,

  allSchools : (state) => {
    const allSchools = [];
    if (state) {
      if (state.selected) {
        allSchools.push(state.selected);
      }

      if (state.childSchools) {
        allSchools.push(...state.childSchools);
      }
    }
    return allSchools;
  }
}
